// «Agregar a Slack» (Estateflow's distributed Slack app): install per workspace (admins) or for the platform
// (platform_integration_admin), channel picker per purpose, test post and disconnect. Schemas in api-slack.ts.
import { OkSchema } from './api.js';
import * as S from './api-slack.js';
import { route, Ws } from './route-def.js';

const cap = 'platform_integration_admin' as const;

export const slackRoutes = {
  getSlack: route({
    method: 'GET', path: '/workspaces/:workspaceId/slack', summary: 'Instalación de la app de Slack del espacio y canal elegido', tag: 'slack',
    minRole: 'admin', module: null, params: Ws, response: S.SlackStatusSchema,
  }),
  startSlackOauth: route({
    method: 'POST', path: '/workspaces/:workspaceId/slack/oauth/start', summary: 'Agregar a Slack (OAuth v2; state ligado a la sesión)', tag: 'slack',
    minRole: 'admin', module: null, params: Ws, body: S.StartSlackOauthSchema, response: S.StartSlackOauthResultSchema,
  }),
  listSlackChannels: route({
    method: 'GET', path: '/workspaces/:workspaceId/slack/channels', summary: 'Canales de Slack disponibles para el bot', tag: 'slack',
    minRole: 'admin', module: null, params: Ws, response: S.SlackConversationListSchema,
  }),
  selectSlackChannel: route({
    method: 'PUT', path: '/workspaces/:workspaceId/slack/channel', summary: 'Elegir el canal de Slack para un propósito', tag: 'slack',
    minRole: 'admin', module: null, params: Ws, body: S.SelectSlackChannelSchema, response: S.SlackStatusSchema,
  }),
  testSlackChannel: route({
    method: 'POST', path: '/workspaces/:workspaceId/slack/test', summary: 'Enviar una prueba por la app de Slack', tag: 'slack',
    minRole: 'admin', module: null, params: Ws, body: S.TestSlackChannelSchema, response: S.SlackAppTestResultSchema,
  }),
  disconnectSlack: route({
    method: 'DELETE', path: '/workspaces/:workspaceId/slack', summary: 'Desinstalar la app de Slack (revoca el token)', tag: 'slack',
    minRole: 'admin', module: null, params: Ws, response: OkSchema,
  }),

  // ─────────── Platform (Estateflow) ───────────
  getPlatformSlack: route({ method: 'GET', path: '/platform/slack', summary: 'App de Slack de Estateflow', tag: 'platform', capability: cap, response: S.SlackStatusSchema }),
  startPlatformSlackOauth: route({
    method: 'POST', path: '/platform/slack/oauth/start', summary: 'Agregar a Slack para Estateflow', tag: 'platform',
    capability: cap, body: S.StartSlackOauthSchema, response: S.StartSlackOauthResultSchema,
  }),
  listPlatformSlackChannels: route({ method: 'GET', path: '/platform/slack/channels', summary: 'Canales del Slack de Estateflow', tag: 'platform', capability: cap, response: S.SlackConversationListSchema }),
  selectPlatformSlackChannel: route({
    method: 'PUT', path: '/platform/slack/channel', summary: 'Elegir canal (alertas o reporte semanal)', tag: 'platform',
    capability: cap, body: S.SelectSlackChannelSchema, response: S.SlackStatusSchema,
  }),
  testPlatformSlackChannel: route({
    method: 'POST', path: '/platform/slack/test', summary: 'Prueba por la app de Slack de Estateflow', tag: 'platform',
    capability: cap, body: S.TestSlackChannelSchema, response: S.SlackAppTestResultSchema,
  }),
  disconnectPlatformSlack: route({ method: 'DELETE', path: '/platform/slack', summary: 'Desinstalar la app de Slack de Estateflow', tag: 'platform', capability: cap, response: OkSchema }),

  // Browser redirect from Slack. Public (no Origin), but the state is bound to the SAME session (+ workspace).
  slackOauthCallback: route({
    method: 'GET', path: '/slack/oauth/callback', summary: 'Retorno OAuth de Slack (redirige a la aplicación)', tag: 'slack',
    public: 'auth', query: S.SlackOauthCallbackQuerySchema, response: S.SlackOauthCallbackResponseSchema,
  }),
};
